import { makeStyles, tokens } from "@fluentui/react-components";

export const useSuggestedRedlinesStyles = makeStyles({
  fullReportListItem: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  redlineCard: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "12px",
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: tokens.borderRadiusLarge,
    border: `1px solid ${tokens.colorNeutralBackground6}`,
    marginBottom: "8px",

    "& > button": {
      alignSelf: "flex-end",
    },

    "& .fui-Accordion": {
      backgroundColor: "transparent",
      border: "none",
      position: "relative",
    },

    "& .fui-AccordionHeader": {
      padding: "4px 0",
      position: "absolute",
    },

    "& .fui-AccordionPanel": {
      padding: "8px 0",
    },
  },
  redlineErrorMessage: {
    color: tokens.colorPaletteRedForeground1,
  },
  redlineInfoMessage: {
    color: tokens.colorPaletteGreenForeground1,
  },
  redlineButtonGroup: {
    display: "flex",
    gap: "2px",
    alignSelf: "flex-end",
  },
  redlineAcceptButton: {
    color: tokens.colorPaletteGreenForeground1,
    "&:hover": {
      backgroundColor: "inherit",
      color: tokens.colorPaletteGreenForeground1,
      textDecoration: "underline",
    },
  },
  redlineRejectButton: {
    color: tokens.colorPaletteRedForeground1,
    "&:hover": {
      backgroundColor: "inherit",
      color: tokens.colorPaletteRedForeground1,
      textDecoration: "underline",
    },
  },

  redlineSentence: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
    justifyContent: "space-between",

    "& svg": {
      flexShrink: 0,
    },
  },
  redlineOriginalSentence: {
    fontWeight: "600",
    textDecoration: "line-through",
    fontSize: "10px",
  },
  redlineReplaceWith: {
    backgroundColor: tokens.colorPaletteGreenBackground1,
    padding: "2px",
    borderRadius: "4px",
    fontSize: "10px",
  },
  redlineAppliedContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    padding: "12px",
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: tokens.borderRadiusLarge,
    border: `1px solid ${tokens.colorNeutralBackground6}`,
    marginBottom: "16px",
  },
  additionalRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
  },
});
